<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXSBBatchNumberList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBBatchNumberForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXSBBatchNumberForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'

const { mapGetters, mapActions } = createNamespacedHelpers('exsbbatchnumber/create')

export default {
  components: {
    EXSBBatchNumberForm
  },

  data () {
    return {
      item: {
        documentsAllowed: []
      }
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBBatchNumberCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXSBBatchNumberUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      item.firstNumber = parseInt(item.firstNumber)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
